// @ts-nocheck

export type TicketGetWithOwner = typeof TicketGetWithOwner[keyof typeof TicketGetWithOwner];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketGetWithOwner = {
  true: 'true',
  false: 'false',
} as const;
